import Axios from '@/assets/js/AxiosPlugin'

// 设置个人信息
export const setUserInfo = params => { return Axios.post('/api/Home/User/setUserInfo', params) }

// 店铺列表
export const getShopList = params => { return Axios.post('/api/Home/User/getShopList', params) }

// 充值
export const preRecharge = params => { return Axios.post('/api/Home/User/preRecharge', params) }

// 充值
export const preSpend = params => { return Axios.post('/api/Home/User/spend', params) }

// 充值列表
export const getRechargeCouponList = params => { return Axios.post('/api/Home/Public/getRechargeCouponList', params) }



// WEBPACK FOOTER //
// ./src/views/mobile/PublicApp/apis/index.js